import { PayloadAction } from '@reduxjs/toolkit';
import { getSavedAdmitadId } from 'lib/admitad';
import { SubscriptionBuyTrialAPICall } from 'reactApp/api/billing/subscription/SubscriptionBuyTrialAPICall';
import { SubscriptionQuickAPICall } from 'reactApp/api/billing/subscription/SubscriptionQuickAPICall';
import { getQueryParams, getSourceString } from 'reactApp/appHelpers/settingsHelpers';
import { getABReactPaymentLink } from 'reactApp/modules/buySubscription/buySubscription.helpers';
import { BillingBuyTemplates, BillingBuyViewTemplates, BuyApiParams } from 'reactApp/modules/buySubscription/buySubscription.types';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { IBuySubscription } from 'reactApp/modules/fastCheckout/fastCheckout.types';
import { getFeatureAbHidePayMethodsMenu, getFeatureAbHidePayMethodsMenuTouch } from 'reactApp/modules/features/features.selectors';
import { call, put, select, takeEvery } from 'redux-saga/effects';

import { FastCheckoutActions } from './fastCheckout.actions';

function* buySubscriptionHandler(action: PayloadAction<IBuySubscription>) {
    const { id, isTrial, isMobile, isVKPay = false } = action.payload;

    const api = isTrial ? new SubscriptionBuyTrialAPICall() : new SubscriptionQuickAPICall();

    yield put(FastCheckoutActions.update({ id, isCheckoutProcessing: true, data: { isLoading: true } }));

    try {
        const admitadId = yield call(getSavedAdmitadId);
        const { partner } = getQueryParams();
        const isPhone = yield select(EnvironmentSelectors.isPhone);

        const source = getSourceString(action.payload.source || '', isPhone);

        const params: BuyApiParams = {
            admitad_uid: admitadId,
            product_id: id,
            source,
        };

        if (partner) {
            params.partner = partner;
        }

        if (isVKPay) {
            params.skin = BillingBuyTemplates.CHECKOUT_VKPAY_NOOFFER;
            params.view = BillingBuyViewTemplates.checkout;
        } else if (isMobile) {
            params.skin = BillingBuyTemplates.CLOUD_B2C_MOBILE;
        }

        // tempexp_14445-start
        const abHidePaymentMethodsMenu = yield select(getFeatureAbHidePayMethodsMenu);
        const abHidePaymentMethodsMenuTouch = yield select(getFeatureAbHidePayMethodsMenuTouch);

        if ((isMobile && abHidePaymentMethodsMenuTouch === 'b') || (!isMobile && abHidePaymentMethodsMenu === 'b')) {
            params.hide_pay_methods_menu = true;
        }
        // tempexp_14445-end

        // @ts-ignore
        const { data } = yield call(api.makeRequest, params);

        const checkoutLink = getABReactPaymentLink(isTrial ? data.url : data.pw, isMobile);

        yield put(
            FastCheckoutActions.update({
                id,
                isCheckoutProcessing: false,
                data: { checkoutLink },
            })
        );
    } catch (error) {
        yield put(FastCheckoutActions.update({ id, isCheckoutProcessing: false, data: { hasError: true } }));
    }
}

export function* watchFastCheckout() {
    yield takeEvery(FastCheckoutActions.buySubscription.toString(), buySubscriptionHandler);
}
